export const ProcessData = [
    {
        id:0,
        title:'INVESTIGATE',
        dec:'We look at the business not just the process. With a customer Goto Market process in mind.'
    },
    {
        id:1,
        title:'MOBILIZE/CUSTOMIZE',
        dec:'Deep Dive into the technologies matching the requirement while looking at the business case, rather than looking at the requirement in Silo.'
    },
    {
        id:2,
        title:'BUILD/SUPPORT',
        dec:'Create concept solution and do solution flow testing. We provide fast and high quality support for all our customers digital needs.'
    },
    {
        id:3,
        title:'GROWTH/MARKETING',
        dec:'Creating proficient tech strategies to drive a continuous stream of profitable traffic to your business, while doing constant solution reviews for future integration options prior to finalization'
    },
]